import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlay, FiX, FiArrowRight } = FiIcons;

const TutorialBanner = ({ isPwdOnly }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Show banner after 5 seconds if it's the user's first visit
    const hasSeenTutorial = localStorage.getItem('hasSeenTutorial');
    if (!hasSeenTutorial) {
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('hasSeenTutorial', 'true');
  };

  const handleWatchTutorial = () => {
    // Track tutorial view
    if (window.gtag) {
      window.gtag('event', 'tutorial_view', {
        'event_category': 'engagement',
        'event_label': 'tutorial_banner'
      });
    }
    // Show tutorial logic here (could open a modal with steps)
    alert('See how to use the calculator in 3 simple steps!');
    setShowBanner(false);
    localStorage.setItem('hasSeenTutorial', 'true');
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl shadow-xl p-4 z-50"
        >
          <button 
            onClick={handleDismiss}
            className="absolute top-2 right-2 text-white/80 hover:text-white"
            aria-label="Close tutorial banner"
          >
            <SafeIcon icon={FiX} />
          </button>

          <div className="flex items-center mb-2">
            <div className="bg-white/20 rounded-full p-2 mr-3">
              <SafeIcon icon={FiPlay} className="text-white text-sm" />
            </div>
            <h3 className="font-medium">New to the calculator?</h3>
          </div>

          <p className="text-sm text-white/90 mb-3">
            Learn how to calculate {isPwdOnly ? 'PWD' : 'Senior/PWD'} discounts correctly in just 30 seconds.
          </p>

          <motion.button 
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={handleWatchTutorial}
            className="w-full bg-white text-blue-600 font-medium rounded-lg py-2 flex items-center justify-center"
          >
            Show Me How <SafeIcon icon={FiArrowRight} className="ml-2" />
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TutorialBanner;